import React from 'react'
import PropTypes from 'prop-types'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { DndProvider } from 'react-dnd'

export { DragSource, DropTarget } from 'react-dnd'

const propTypes = {
    className: PropTypes.string
}

function DragAndDropContext(props) {
    const { children, className } = props

    return (
        <DndProvider backend={HTML5Backend}>
            <div className={className}>{children}</div>
        </DndProvider>
    )
}

DragAndDropContext.propTypes = propTypes

export default DragAndDropContext
